<template>
    <v-dialog persistent v-model="dialog" width="30%">
        <v-card fluid>
            <v-card-title>
                {{ parc.eigncode }} {{ parc.eignnaam }} - {{ parc.parkname }}
            </v-card-title>
            <v-divider  class="ml-2 mr-2 mb-2"></v-divider>
            <v-card-text>
            <v-row cols="12" dense class="flex-row">
                <v-col cols="3" offset="1" class="mt-1 pr-3">
                    <v-text-field v-model="parkcode_new" label="Park code"></v-text-field>
                </v-col>
                <v-col cols="4" class="pr-3 flex-row">
                    <v-btn small color="success" @click="$refs.get_parc_code.open('parkcode_new')">
                        try and get...
                    </v-btn>
                    <div class="mt-1 ml-4">
                        <v-checkbox label="Test" v-model="isTest"></v-checkbox>
                    </div>                    
                </v-col>                    
            </v-row>                
            <v-row dense>                
                <v-col cols="10" offset="1">
                    <v-text-field dense v-model="parkname" label="Park name"></v-text-field>
                </v-col>
            </v-row>            
            <v-row cols="12" dense>
                <v-col cols="5" offset="1" class="mb-2 pr-3 flex-row">             
                    <select_margin_calculation label="Calculation method" field="calculationcode" :selected_calculationcode="calculationcode"  @updateData="updateData"/>
                </v-col>
                <v-col cols="2" offset="1">
                    <input_amount label="Margin" prefix="%" :amount="margin" field="margin" @updateData="updateData"/>
                </v-col>                    
            </v-row>                    
            <v-row dense>
                <v-col cols="10" offset="1" style="min-height: 50px;">
                    <i>Calculation: {{ this.calculation_explanation }}</i>
                </v-col>
            </v-row> 

        </v-card-text>
        <v-divider  class="ml-2 mr-2"></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>              
                <v-btn @click="closeDialog" color="primary">
                    cancel
                </v-btn>                  
                <v-btn @click="saveParcData" color="success">
                    save
                </v-btn>
            </v-card-actions>
        </v-card>
        <get_parc_code ref="get_parc_code" @updateData="updateData" />
    </v-dialog>
</template>

<script>
    
    import input_amount from '@/components/huis/hspt/ui/input_amount.vue';
    import select_margin_calculation from '@/views/task/pp/select_margin_calculation.vue';
    import get_parc_code from "@/views/task/pp/get_parc_code.vue";

    export default {
        components: {
            input_amount,
            select_margin_calculation,
            get_parc_code
        },        
        data() {
            return {
                parc: {},
                dialog: false,
                margin: '',
                parkcode_new: '',
                parkname: '',
                calculationcode: '',
                calculation_name: '', 
                calculation_explanation: '',
                calculationcodes: [],
                isTest: null
            }
        },    
        methods: {
            open(parc) {
                this.parc = parc;
                this.margin = this.toDutchNumberFormat(this.parc.margin);
                this.calculationcode = this.parc.calculationcode;
                this.dialog = true;           
                this.parkname = this.parc.parkname
                this.parkcode_new = this.parc.parkcode     
                this.isTest = this.parc.isTest
            },                    
            closeDialog() {
                this.dialog = false;
                // this.$emit('reload');
            },        
            updateData(data){              
                if(Array.isArray(data)){
                    this[data[0].field] = data[0].value
                    this[data[1].field] = data[1].value
                    this[data[2].field] = data[2].value
                } else {
                    this[data.field] = data.value
                }
            },            
            toDutchNumberFormat(value) {
                // decimal seperator must be "," for input value
                if(value != null && value != '' && value != '0') {    
                    if((""+value).includes(",")) { // is NL format?  (JS number format only contains a decimal dot --> not a thousand separator comma)        
                        value = ((""+value).replace(".", "")).replace(",", "."); // first restore JS number format if needed then return NL format for complete value
                    } 
                    return new Intl.NumberFormat('nl-NL', {style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2}).format(+value);
                } else {
                    return '0';
                }
            },      
            saveParcData(){

                this.parc.margin = Number((this.margin).replace(",", "."))
                this.parc.calculationcode = this.calculationcode
                this.parc.calculationcode_description = this.calculation_name
                this.parc.parkcode_new = this.parkcode_new
                this.parc.parkname = this.parkname
                this.parc.isTest = this.isTest
                
                this.$axios
                    .post("ares/json/ares/task/pp/saveParkInfov2.p", {
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "saveParcInfo"
                        }, 
                        saveParcInfo: this.parc
                    })
                    .then(res => {
                        if (res.data.error) {
                            console.log(res.data.error.message);
                        } else {
                            this.closeDialog();
                        }
                    })

            }
        }
    }
</script>

<style scoped>
.flex-row{
    display: flex;
    flex-direction: row;
    align-items: center;
}
.text-color{
    color: black !important;
}

</style>